export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      width: '100%',
      minWidth: 0,
      fontFamily: theme?.typography?.fontFamily,
      height: '100%',
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: { xs: 'stretch', md: 'flex-end' },
      gap: '8px',
      flexWrap: 'wrap',
    },
    viewSubmissionsButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      height: '42px',
      width: { xs: '100%', md: 'auto' },
    },
    noResultsCard: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      borderRadius: theme?.shape?.borderRadius ?? 2,
      bgcolor: isDark ? '#231F29' : '#F8F7F9',
      pt: { xs: '12px', sm: '12px', md: '16px' },
      px: { xs: '16px', sm: '16px', md: '16px' },
      pb: { xs: '12px', sm: '12px', md: '16px' },
      opacity: 1,
      boxSizing: 'border-box',
    },
    noResultsCardTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '1rem',
      lineHeight: '175%',
      letterSpacing: '0.15px',
      color: 'text.primary',
      textAlign: 'center',
      mt: '-0.25rem',
    },
    noResultsCardDescription: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.17px',
      textAlign: 'center',
      color: 'text.secondary',
      whiteSpace: 'pre-line',
    },
  };
};
